import http, { get, post } from "@/utils/http";

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

//日报列表查询所有
// export const getDailyPaperAll = async params => {
//     const res = await post(`/dailypaper/select`, params);
//     return res;
// };

export const login = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/blade-auth/token`, {},params,headers);
  return res;
};
export const regist = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/blade-user/submit`, params,headers);
  return res;
};


export const saveOrUpdate = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/enrollinfo/saveOrUpdate`, params,params,headers);
  return res;
};

export const createOrder = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/aliPay/createOrder`, params,params,headers);
  return res;
};
export const getScoreByEnrollId = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/scoringscoresheet/getScoreByEnrollId`, params);
  return res;
};
 
export const sendCode = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/msg/sendCode`, params);
  return res;
};


export const getScore = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/scoringscoresheet/page`, params);
  return res;
};

export const print = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/pdf/generate`, {},params,headers,"blob");
  return res;
};

export const apply = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/enrollinfo/enrollInfoApply`,params);
  return res;
};

//  岗位申请的重复报名是否确认提交
export const isSubmit = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/enrollinfo/isSubmit`,params);
  return res;
}

export const getReviewDetail = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/enrollinfo/detail`,params, );
  return res.data;
};
export const removeEnrollInfo = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/enrollinfo/remove`,params, );
  return res;
};

export const getPoliticalOutlook = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/bladeDict/politicalOutlook`, params);
  return res;
};

export const getEduData = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/bladeDict/getDict/qualification`, params);
  return res;
};

export const getNowPayStatus = async (params?: Object ,headers?:Object) => {
  const res : AxiosResponse = await get(`/aliPay/getNowPayStatus` , params);
  return res; 
};

export const noticeDetail = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await get(`/noticecontent/detail`, params);
  return res;
};


export const getzpNoticList = async (params?: Object) => {
  const res: AxiosResponse = await get(`/noticecontent/list`, params);
  return res.data;
};
export const getPostNoticList = async (params?: Object) => {
  const res: AxiosResponse = await get(`/noticepostexampoints/page`, params);
  return res.data;
};
export const canVerify = async (params?: Object) => {
  const res: AxiosResponse = await get(`/blade-auth/verifyCode`, params);
  return res;
};

export const getNoticDetail = async (params?: Object) => {
  const res: AxiosResponse = await get(`/noticecontent/detail`, params);
  return res.data;
};

export const countView = async (noticeId: String) => {
  const res: AxiosResponse = await get(`/noticecontent/countView/${noticeId}`);
  return res.data;
};


//省市区集合
export const getCityList = async (params?: Object) => {
  const res: AxiosResponse = await post(`/regionalnavigation/getHB`, params);
  return res.data;
};

//全国省市区集合
export const getAllCityList = async (params?:Object) => {
  const res : AxiosResponse = await post(`/regionalnavigation/getAllCityList` , params);
  return res.data;
}


//验证码
export const getCaptcha = async (params?: Object) => {
  const res: AxiosResponse = await get(`/blade-auth/captcha`, params);
  return res.data;
};

//报名提交验证手机
export const checkPhone = async (params?: Object) => {
  // 发送一个 GET 请求到 '/msg/verifyPhoneCorrect' 端点，携带参数 params
  const res: AxiosResponse = await get(`/msg/verifyPhoneCorrect`, params);
  // 返回请求响应中的 data 字段
  return res;
};



//资格审查列表
export const getReviewList = async (params?: Object,headers?:Object) => {
  const res: AxiosResponse = await post(`/enrollinfo/getAllInfo`,{}, params);
  return res;
};



//日报列表查询

export const getDailyPaper = async (params?: Object) => {
  const res: AxiosResponse = await post(`/dailypaper/selectdailyinfo`, params);
  return res;
};

//月报列表查询
export const getMonthPaper = async (params) => {
  const res = await post(`/dailypaper/selectmonthinfo`, params);
  return res;
};

//月报详情
export const getMonthPaperDetail = async (params) => {
  const res = await post(`/projects/selectmonthprojectinfo`, params);
  return res;
};

//月报详情
export const getProject = async (params?: Object) => {
  const res = await post(`/projects/selectprojectdetail`, params);
  return res;
};

//日报列表查询

export const getStatistics = async (params?: Object) => {
  const res: AxiosResponse = await post(`/projects/selectprojectdetail2`, params);
  return res;
};

//查询所有员工列表

export const getUserList = async (params?: Object) => {
  const res: AxiosResponse = await get(`/syswxuser/selectall`, params);
  return (res as any).resultData;
};

//同步
export const setSynchronizeUsers = async (params?: Object) => {
  const res: AxiosResponse = await post(`/task/synchronizeUsers`, params);
  return (res as any).resultData;
};

//查询所有员工列表
export const getCalendar = async (params?: Object) => {
  const res: AxiosResponse = await post(`/calendar/getbetweencalendarinfo`, params);
  return (res as any).resultData;
};


//获取项目列表方法
export const getProjectList = async (params: object) => {
  const res = await get(`/projects/selectall`, params);
  return (res as any).resultData;
};

//获取项目模块列表
export const getProjectModuleList = async (params: object) => {
  const res = await post(`/projectmodule/select`, params);
  return (res as any).resultData;
};

//获取功能点列表
export const getPointList = async (params: object) => {
  const res = await post(`/functionpoint/select`, params);
  return (res as any).resultData;
};


//添加模块
export const addModule = async (params: object) => {
  const res = await post(`/projectmodule/add`, params);
  return (res as any).resultData;
};

//添加功能点
export const addMPoint = async (params: object) => {
  const res = await post(`/functionpoint/add`, params);
  return (res as any).resultData;
};

//添加项目
export const addProject = async (params: object) => {
  const res = await post(`/projects/add`, params);
  return (res as any).resultData;
};

//合同查询
export const selectContracts = async (params: object) => {
  const res = await post(`/contracts/select`, params);
  return (res as any).resultData;
};

//合同查询
export const getContract = async (params?: Object) => {
  const res: AxiosResponse = await post(`/contracts/select`, params);
  return res;
};

//新增合同
export const addContract = async (params?: Object) => {
  const res: AxiosResponse = await post(`/contracts/add`, params);
  return (res as any);
};

//修改合同
export const updateContract = async (params?: Object) => {
  const res: AxiosResponse = await post(`/contracts/update`, params);
  return (res as any);
};

//添加模块
export const addProjectModule = async (params?: Object) => {
  const res: AxiosResponse = await post(`/projectmodule/add`, params);
  return (res as any);
};  

export const getPhoto = async (params?: Object) => {
  const res: AxiosResponse = await get(`/blade-auth/getPhoto`, params);
  return res;
};

export const updateUser = async (params?: Object) => {
  const res: AxiosResponse = await post(`/blade-user/update`, params);
  return res;
};


export const getUser = async (params?: Object) => {
  const res: AxiosResponse = await get(`/blade-user/info`, params);
  return res;
};

export const updateUserPassword = async (params?: Object) => {
  const res: AxiosResponse = await post(`/blade-user/updateUser`, params);
  return res;
}


export const getUser1 = async (params?: Object) => {
  const res: AxiosResponse = await post(`/blade-user/infoback`, params);
  return res;
};


export const getCarouselPicture = async (params?: Object) => {
  const res: AxiosResponse = await post(`/otherInfo/getCarouselPicture`, params);
  return res;
};

export const getAdPicure = async (params?: Object) => {
  const res: AxiosResponse = await post(`/otherInfo/getAdPicture`, params);
  return res;
};

export const sendRestCode = async (params?: Object) => {
  const res: AxiosResponse = await get(`/msg/restPassword`, params);
  return res;
};

export const restPassword = async (params?: Object) => {
  const res: AxiosResponse = await post(`/blade-user/userUpdatePassword`, params);
  return res;
};

export const getUserInfo = async (params?: Object) => {
  const res: AxiosResponse = await get(`/enrollinfo/getUserInfo`, params);
  return res;
};

export const verifyPhoneCorrect = async (params?: Object) => {
  const res: AxiosResponse = await get(`/msg/verifyPhoneCorrect`, params);
  return res;
};

export const cancelRegistrationz = async (params?: Object) => {
  const res: AxiosResponse = await get(`/enrollinfo/cancelRegistration`, params);
  return res;
};